export enum EEmployeePermission {
	ADD_MACHINES = 'mes_add_machines',
	ADD_PRODUCTION_CELLS = 'mes_add_production_cells',
	ADD_SUPPLIERS = 'mes_add_suppliers',
	ADVANCED_MONITORING = 'mes_advanced_monitoring',
	APPROVE_PURCHASE_ORDERS = 'mes_approve_purchase_orders',
	ARCHIVE_PRODUCTION_CELLS_AND_MACHINES = 'mes_archive_production_cells_and_machines',
	ASSIGN_TEMPORARY_ROLES = 'mes_assign_temporary_roles',
	AUTO_GENERATE_DAILY_REPORTS = 'mes_auto_generate_daily_reports',
	CONFIGURE_HALL_PLAN = 'mes_configure_hall_plan',
	CONFIGURE_PRODUCTION_BREAKS = 'mes_configure_production_breaks',
	COPY_PRODUCTION_CONFIGURATION = 'mes_copy_production_configuration',
	CREATE_CUSTOM_REPORT_TEMPLATES = 'mes_create_custom_report_templates',
	CREATE_ORDER_SIMULATION = 'mes_create_order_simulation',
	DELAY_DOWNTIME_NOTIFICATIONS = 'mes_delay_downtime_notifications',
	EDIT_MACHINES = 'mes_edit_machines',
	EDIT_PRODUCTION_CELLS = 'mes_edit_production_cells',
	EDIT_RAW_MATERIALS = 'mes_edit_raw_materials',
	EXPORT_REPORTS = 'mes_export_reports',
	GENERATE_MEAL_REPORT = 'mes_generate_meal_report',
	GENERATE_PURCHASE_ORDERS = 'mes_generate_purchase_orders',
	GENERATE_SEMI_PRODUCT_REPORT = 'mes_generate_semi_product_report',
	MANAGE_INVENTORY = 'mes_manage_inventory',
	MANAGE_MEAL_SCHEDULE = 'mes_manage_meal_schedule',
	MANAGE_PACKAGING_SCHEDULE = 'mes_manage_packaging_schedule',
	MANAGE_PROMARK_LABELS = 'mes_manage_promark_labels',
	MANAGE_SEMI_PRODUCT_SCHEDULE = 'mes_manage_semi_product_schedule',
	PURCHASE_ORDERS_REPORT = 'mes_purchase_orders_report',
	RAW_MATERIALS_COMPLETION_REPORT = 'mes_raw_materials_completion_report',
	REGISTER_PRODUCTION_ERRORS = 'mes_register_production_errors',
	SAVE_SIMULATION_VERSION = 'mes_save_simulation_version',
	SET_PACKAGING_CAPACITY = 'mes_set_packaging_capacity',
	SET_PRODUCTION_CELL_PERSONNEL = 'mes_set_production_cell_personnel',
	SIMULATION_COMMENTS = 'mes_simulation_comments',
	TRAY_COMPLETION_REPORT = 'mes_tray_completion_report',
	USER_ACCOUNT_MANAGEMENT = 'mes_user_account_management',
	VIEW_LOGIN_AND_USER_OPERATION_HISTORY = 'mes_view_login_and_user_operation_history',
	VIEW_MEAL_DETAILS = 'mes_view_meal_details',
	VIEW_PRODUCTION_HALL_LIVE = 'mes_view_production_hall_live',
	VIEW_PRODUCTION_PLAN = 'mes_view_production_plan',
	VIEW_RAW_MATERIALS_LIST = 'mes_view_raw_materials_list',
	VIEW_SEMI_PRODUCT_DETAILS = 'mes_view_semi_product_details',
	VIEW_WORKSTATION_DETAILS = 'mes_view_workstation_details',

	//production-settings
	VIEW_PRODUCTION_MACHINES = 'mes_view_production_machines',
	VIEW_PRODUCTION_MACHINE_DETAILS = 'mes_view_production_machine_details',
	ADD_PRODUCTION_MACHINE = 'mes_add_production_machine',
	EDIT_AND_DELETE_PRODUCTION_MACHINE = 'mes_edit_and_delete_production_machine',
	VIEW_PRODUCTION_SOCKETS = 'mes_view_production_sockets',
	VIEW_PRODUCTION_SOCKET_DETAILS = 'mes_view_production_socket_details',
	ADD_PRODUCTION_SOCKETS = 'mes_add_production_sockets',
	EDIT_AND_DELETE_PRODUCTION_SOCKETS = 'mes_edit_and_delete_production_sockets',
	VIEW_PRODUCTION_SIMULATION_TABLET_INSTRUCTIONS = 'mes_view_production_simulation_tablet_instructions',
	MANAGE_PRODUCTION_SIMULATIONS = 'mes_manage_production_simulations',
	MANAGE_FACILITY_ASSIGNMENT_PLAN = 'mes_manage_facility_assignment_plan',
	VIEW_SEMI_PRODUCT_SOCKET_ASSIGNMENTS = 'mes_view_semi_product_socket_assignments',
	MANAGE_SEMI_PRODUCT_SOCKET_ASSIGNMENTS = 'mes_manage_semi_product_socket_assignments',

	CREATE_PURCHASE = 'mes_create_purchase',
	VIEW_PURCHASE = 'mes_view_purchase',
	MANAGE_PURCHASE = 'mes_manage_purchase',
	APPROVE_PURCHASE = 'mes_approve_purchase',
	CANCEL_PURCHASE = 'mes_cancel_purchase',
	RECEIVE_PURCHASE = 'mes_receive_purchase',
	CREATE_PURCHASE_ORDER = 'mes_create_purchase_order',
	VIEW_PURCHASE_ORDER = 'mes_view_purchase_order',
	MANAGE_PURCHASE_ORDERS = 'mes_manage_purchase_orders',
	MANAGE_PURCHASE_ORDER = 'mes_manage_purchase_order',
	APPROVE_PURCHASE_ORDER = 'mes_approve_purchase_order',
	CANCEL_PURCHASE_ORDER = 'mes_cancel_purchase_order',
	RECEIVE_PURCHASE_ORDER = 'mes_receive_purchase_order',

	VIEW_SUPPLIERS = 'mes_view_suppliers',
	EDIT_AND_DELETE_SUPPLIERS = 'mes_edit_and_delete_suppliers',
	VIEW_SUPPLIER_DETAILS = 'mes_view_supplier_details',
	MANAGE_DELIVERIES_AND_RECEIPTS = 'mes_manage_deliveries_and_receipts',
}
